import React, { createContext, useContext, useState } from 'react';

const KybModalContext = createContext();

export const KybModalProvider = ({ children }) => {
  const [showKybModal, setShowKybModal] = useState(false);

  const openKybModal = () => {
    setShowKybModal(true);
  };

  const closeKybModal = () => {
    setShowKybModal(false);
  };

  return (
    <KybModalContext.Provider
      value={{
        showKybModal,
        openKybModal,
        closeKybModal,
      }}
    >
      {children}
    </KybModalContext.Provider>
  );
};

export const useKybModal = () => {
  return useContext(KybModalContext);
};
